import { useQueryClient } from '@tanstack/react-query'
import { useNavigate, useRouter } from '@tanstack/react-router'
import { signOut } from 'firebase/auth'
import { auth } from '@/lib/firebase'
import { FLEX_SESSION_ACTIVITY_KEY } from '@/data/constants'
import { useSelectedTenantStore } from '@/stores/useSelectedTenantStore'

type SignOutDestination = '/login' | '/session-timeout'

interface SignOutOptions {
  redirectTo?: SignOutDestination
}

export const useSignOut = () => {
  const queryClient = useQueryClient()
  const router = useRouter()
  const navigate = useNavigate()
  const setSelectedTenantId = useSelectedTenantStore(
    (state) => state.setSelectedTenantId,
  )

  return async (options?: SignOutOptions) => {
    const redirectTo = options?.redirectTo ?? '/login'
    try {
      await signOut(auth)
    } finally {
      window.localStorage.removeItem(FLEX_SESSION_ACTIVITY_KEY)
      queryClient.clear()
      navigate({ to: redirectTo })
      setTimeout(() => {
        router.invalidate({
          filter: (route) => route.id.includes('_authenticated'),
        })
        setSelectedTenantId(null)
      }, 0)
    }
  }
}
